import React from "react";
import styles from "../styles/NotFound.module.scss";

export default function NotFound() {
  return (
    <div className={styles.errorPage}>
      <div className={styles.errorMessageContainer}>
        <img
          className={styles.logo}
          src={"https://frontend-assets.buildbox.com/logo.png"}
          alt="bb_logo"
        ></img>
        <div className={styles.messageContainer}>
          <p className={styles.message}>
            Sorry, page not found!
            <img
              src={"https://frontend-assets.buildbox.com/404_dog.gif"}
              alt="everything is fine"
            />
          </p>
        </div>
      </div>
    </div>
  );
}
